export const VERSION = "2024.09";
export const UPDATE_NEWS_LINK = "https://public.app.shortcut.com/bf/fomin-clinic/docs/38Ao0m6TxhfuyQMyj2LA8k/september-2024";
